<template>
    <div style="width: 100%;height: 100%;">
        <MobileHeader active="home"></MobileHeader>



        <div class="swiper-container" style="width: 100%">
            <!-- Additional required wrapper -->
            <div class="swiper-wrapper" style="width: 100%">
                <!-- Slides -->
                <div class="swiper-slide" v-for="item in bannerList" v-bind:key="item.id" style="width: 100%" @click="onBannerClick(item)">
                    <img  :src="item.img" style="height: auto; width: 100%"  />
                </div>
            </div>
            <!-- If we need pagination -->
            <div class="swiper-pagination"></div>

            <!-- If we need navigation buttons -->
            <div class="swiper-button-prev swiper-button-white"></div>
            <div class="swiper-button-next swiper-button-white"></div>

        </div>


        <!--<el-carousel arrow="always" :height="bannerHeight" indicator-position="none">-->
            <!--<el-carousel-item v-for="item in bannerList" v-bind:key="item.id" @click="onBannerClick(item)">-->
                <!--<img class="banner-img" ref="banner" :src="item.img" v-bind:class="{'pointer': item.clickable}" @click="onBannerClick(item)" @load="onImgLoad(item)" />-->
            <!--</el-carousel-item>-->
        <!--</el-carousel>-->

        <el-row class="news-container">
            <div v-for="item in newsList" v-bind:key="item.id" class="card-item">
                <el-image class="news-img" :src="item.image" @click="toDetail(item.id)"></el-image>
                <el-row class="news-align">
                    <h3 class="news-title" @click="toDetail(item.id)">{{item.title}}</h3>
                </el-row>
                <el-row class="news-align news-summary" >
                    <div @click="toDetail(item.id)">{{item.summary}}</div>
                </el-row>
                <el-row class="news-button">
                    <!--<el-button  plain @click="toNewsDetail(item.id)">详细信息</el-button>-->
                    <!--<MainButton>详细信息</MainButton>-->
                </el-row>
            </div>
        </el-row>

        <MobileFooter></MobileFooter>
    </div>
</template>

<script>
    import MobileHeader from "../../components/MobileHeader";
    import {newsApi} from "../../api/news-api";
    import MobileFooter from "../../components/MobileFooter";
    import Swiper from 'swiper/bundle';
    import {global} from '../../utils/global'

    export default {
        name: "MobileHome",
        components: {MobileFooter, MobileHeader},
        data () {
            return {
                bannerList: [
                    {
                        id: 0,
                        img: `${global.RESOURCE_PREFIX}/images/首页001.jpg`,
                        clickable: false
                    },
                    {
                        id: 1,
                        img: `${global.RESOURCE_PREFIX}/images/首页002.jpg`,
                        clickable: false
                    },
                    {
                        id: 2,
                        img: `${global.RESOURCE_PREFIX}/images/首页003.jpg`,
                        clickable: false
                    },
                    {
                        id: 3,
                        img: `${global.RESOURCE_PREFIX}/images/首页004.jpg`,
                        clickable: true,
                        businessName: 'data'
                    },
                    {
                        id: 4,
                        img: `${global.RESOURCE_PREFIX}/images/首页005.jpg`,
                        clickable: true,
                        businessName: 'equipment'
                    }

                ],
                newsList: [],
                bannerHeight: null
            }
        },
        mounted () {
          this.listNews();
          this.initSwiper();
        },
        methods: {
            listNews () {
                newsApi.list({
                    type: 1,
                    status: 1,
                    page: 1,
                    limit: 3
                }).then(res => {
                    if (res.code === 200) {
                        this.newsList = res.page.list;
                    }
                })
            },
            toDetail (id) {
                this.$router.push({
                    path: `/detail/${id}`,
                    query: {
                        active: 'news'
                    }
                })
            },
            onBannerClick (item) {
                if (! item.clickable) {
                    return;
                }
                if (item.businessName) {
                    this.toBusiness(item.businessName);
                }
            },
            toBusiness (businessName) {
                const routeParams = {
                    path: '/business'
                };
                if (businessName) {
                    routeParams.query = {
                        businessName: businessName
                    };
                }
                this.$router.push(routeParams);
            },
            onImgLoad (item) {
                console.log(item);
                this.bannerHeight = this.$refs['banner'][item.id].offsetHeight + 'px';
            },
            initSwiper () {
                new Swiper('.swiper-container', {
                    loop: true,
                    autoplay:true,
                    // If we need pagination
                    pagination: {
                        el: '.swiper-pagination',
                    },

                    // Navigation arrows
                    navigation: {
                        nextEl: '.swiper-button-next',
                        prevEl: '.swiper-button-prev',
                    }
                })
            }
        }
    }
</script>

<style scoped>

    .hiden{
        /*overflow: hidden;*/
        /*text-overflow: ellipsis;*/
        display: -webkit-box;
        /*-webkit-line-clamp: 3;*/
        -webkit-box-orient: vertical;
        color: grey ;
        text-align: left;

    }
    .img{
        display: inline-block;
        width: 100%;
        max-width: 100%;
        height: 35rem;
    }
    .title{
        padding-top:2rem;
        padding-bottom: 1rem;
    }
    .DrawerPage {
        position: fixed;
        width: 100%;
        height: 100%;
        left: 0vw;
        background-color: #f1f1f1;
        transition: all 0.4s;
    }



    .DrawerWindow {
        position: absolute;
        height: 40rem;
        right: 0;
        top: 0;
        margin-top: 10rem;
        transform: scale(0.9, 0.9) translateX(100%);
        opacity: 0;
        pointer-events: none;
        transition: all 0.4s;
    }

    .DrawerWindow.show {
        transform: scale(1, 1) translateX(0%);
        opacity: 1;
        pointer-events: all;
    }

    .DrawerClose {
        position: absolute;
        width: 100%;
        height: 100%;
        right: 0;
        top: 0;
        color: transparent;
        padding-bottom: 10rem;
        display: flex;
        align-items: flex-end;
        justify-content: center;
        background-image: linear-gradient(90deg, rgba(0, 0, 0, 0.01), rgba(0, 0, 0, 0.6));
        letter-spacing: 5px;
        font-size: 3rem;
        opacity: 0;
        pointer-events: none;
        transition: all 0.4s;
    }

    .DrawerClose.show {
        opacity: 1;
        pointer-events: all;
        width: 100%;
        color: #fff;
    }
    .backgroundcolor .text-black{
        background-color: rgb(0, 153, 255) !important ;
    }

    .cu-item.arrow:hover{
        background-color: rgb(0, 153, 255) !important ;
    }
    .cu-item.arrow:hover .text-black{
        color: white;
    }
    .shaow{
        box-shadow: 0 0 0 100rem rgba(0, 0, 0, 0.5);
        z-index: auto;
    }

    html,
    body {
        position: relative;
        height: 100%;
        width: 100%;
        background-color: white;
    }

    body {
        background: white;
        font-family: Helvetica Neue, Helvetica, Arial, sans-serif;
        /* font-size: 14px; */
        color: #000;
        margin: 0;
        padding: 0;
        background-color: white;
    }

    .banner-img {
        width: 100%;
        height: auto;
        object-fit: fill;
    }

    .news-container {
        padding: 0 5%;
        margin-top: 25px;
    }
    .card-item {
        width: 100%;
        background-color: rgb(244, 244, 244);
        text-align: left;
        margin-bottom: 3rem;
    }
    .news-summary {
        font-size: 15px;
        line-height: 25px;

        overflow:hidden;
        text-overflow:ellipsis;
        display:-webkit-box;
        -webkit-line-clamp:5;
        -webkit-box-orient:vertical;
    }
    .news-align {
        text-align: left;
        padding: 0 5%;
    }

    .news-title {
        overflow:hidden;
        text-overflow:ellipsis;
        display:-webkit-box;
        -webkit-line-clamp:2;
        -webkit-box-orient:vertical;
        cursor: pointer;
    }

    .news-button {
        text-align: center;
        padding: 20px 0;
    }

    .swiper-container {
        width: 100%;
      --swiper-pagination-color: #ffffff;
      --swiper-navigation-size: 24px;/* 设置按钮大小 */
    }
</style>
